import { default as colors } from "./colors";
import { sxFont_16_500, sxFontFamily } from "./sxFont";

export const sxButtonBase = {
  textTransform: "none",
};

export const sxButton = {
  ...sxButtonBase,
  color: colors.white,
  background: colors.primaryOzone500,
  borderRadius: "12px",
  padding: "12px 18px",
  ...sxFontFamily,
  ...sxFont_16_500,
  "&:hover": {
    color: colors.white,
    background: colors.ozone,
  },
};
